/**
 * @file: screens.ts
 *
 * The chat pages that make up a conversation surface + the derived param
 * types. One map, two hosts: the app-level `ChatFlow` (pushed on the root
 * stack) and the floating panel's standalone stack — both spread exactly these
 * screens, so a new chat page is registered once.
 *
 * `_chatConversation` is first, so a navigator that spreads this map without
 * an explicit `initialRouteName` opens the conversation.
 */

import { ChatContactPickerScreen } from '@euler/app/flows/chat/pages/contact-picker';
import { ChatConversationScreen } from '@euler/app/flows/chat/pages/conversation';
import { ChatRoomDetailScreen } from '@euler/app/flows/chat/pages/room-detail';
import { ScreenToParams } from '@euler/functions/spreadScreens';

export const ChatScreens = {
  _chatConversation: ChatConversationScreen,
  _chatRoomDetail: ChatRoomDetailScreen,
  _chatContactPicker: ChatContactPickerScreen,
};

export type ChatNavParams = ScreenToParams<typeof ChatScreens>;
